// The firm's time zone for a page that dates things on the firm's clock
// (utils/eventTime.js firmTz(), utils/todoDue.js) — including when the page
// runs as a pop-out.
//
// Layout sets window.__lextrackFirmTz from GET /api/settings, but a pop-out
// (/popup/page/…) renders under PopupLayout, which never does: a popped-out
// window is its own renderer with its own `window`.  There every firm-clock
// helper silently falls back to America/Los_Angeles while the server dates
// rows by firm_settings.timezone (settings-firm.md, "Firm timezone"; verifier
// 2026-10-17 on the Daily Snapshot and Deadlines pop-outs).  Same for a main
// window page that renders before Layout's own request returns.
//
// When the zone is not known yet this fetches it once, sets the window global
// (so the helpers read it) and re-renders the caller, whose labels then use
// it.  Returns the zone, or null until it is known.  A failed request leaves
// the Pacific fallback, as Layout does; the page's own data request reports
// errors.

import { useEffect, useState } from 'react'
import api from '../services/api'

export default function useFirmTimezone () {
  const [tz, setTz] = useState(() => (typeof window !== 'undefined' && window.__lextrackFirmTz) || null)
  useEffect(() => {
    if (window.__lextrackFirmTz) {
      if (tz !== window.__lextrackFirmTz) setTz(window.__lextrackFirmTz)
      return undefined
    }
    let cancelled = false
    api.get('/api/settings')
      .then(r => {
        const zone = r && r.data && typeof r.data.timezone === 'string' && r.data.timezone ? r.data.timezone : null
        if (!zone) return
        // Set before the state update, so the re-render it causes reads it.
        window.__lextrackFirmTz = zone
        if (!cancelled) setTz(zone)
      })
      .catch(() => {})
    return () => { cancelled = true }
    // Once per mount: the global, once set, is shared by every later caller.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return tz
}
